/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IObrienLocatorViewProps } from './obrien-locator';

export default (props: IObrienLocatorViewProps) => {
  const { obIframe } = props;

       return (
        <div>
          <div dangerouslySetInnerHTML={{ __html: obIframe}}></div>
        </div>
       );
};


